import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

function TotalStats({stats}) {
  const formatRevenue = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format(value);
  };

  return (
    <Row>
      {stats.map((stat, index) => (
        <Col xl={3} md={6} key={index}>
          <Card className="mini-stats-wid">
            <CardBody>
              <div className="d-flex">
                <div className="flex-grow-1">
                  <p className="text-muted fw-medium mb-2">{stat.title}</p>                  
                  <h4 className="mb-0">{stat.count}</h4>
                  <h6 className="mt-2 mb-0">
                    Revenue: <span className={`${Number(stat.revenue) > 0 ? 'text-success' : 'text-danger' }`}>{formatRevenue(stat.revenue)}</span>
                  </h6>
                </div>
                <div
                  className={`avatar-sm align-self-center mini-stat-icon rounded-circle bg-${stat.color}`}
                >
                  <span className="avatar-title">
                    <i className={`bx ${stat.icon} font-size-24`}></i>
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  );
}

export default TotalStats;
